import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Input = props => {
  const inputRef = useRef();
  const {
    prefix,
    prefixClass,
    suffix,
    suffixClick,
    suffixClass,
    placeholder,
    type,
    borderClass,
    className,
    ...restProps
  } = props;
  const inputClass = `input ${className}`;
  const prefixIconClassName = `material-icons-round prefix ${prefixClass}`;
  const suffixClassName = `material-icons-round suffix ${suffixClass}`;
  const inputBorderClass = `input-container ${borderClass}`;

  return (
    <div className={inputBorderClass}>
      {prefix && <span className={prefixIconClassName}>{prefix}</span>}
      <input
        ref={inputRef}
        autoComplete="off"
        type={type}
        placeholder={placeholder}
        className={inputClass}
        {...restProps}
      />
      {suffix && (
        <span className={suffixClassName} onClick={() => suffixClick(inputRef.current)}>
          {suffix}
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  prefix: PropTypes.string,
  prefixClass: PropTypes.string,
  suffix: PropTypes.string,
  suffixClick: PropTypes.func,
  suffixClass: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  borderClass: PropTypes.string,
};

Input.defaultProps = {
  prefix: '',
  prefixClass: '',
  suffix: '',
  suffixClick: () => {},
  suffixClass: '',
  placeholder: '',
  className: '',
  borderClass: '',
};

export default Input;
